import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { palmdaleConfig } from "./data";

export default function PalmdalePage() {
  return <CityPageTemplate config={palmdaleConfig} />;
}